import styled from 'styled-components';

export const ContentWrapper = styled.div`
  flexdirection: column;
  padding: 0 0 ${({ theme }) => theme.spacing.km6};
  filter: blur(12px);
  pointer-events: none;
  user-select: none;
`;

export const ClickableArea = styled.div``;
